// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.policy-layout[data-v-5e46a9a4] {\n    overflow: auto;\n    height: 100vh;\n    background-color: #f5f5f5;\n}\n.policy-layout-footer[data-v-5e46a9a4] {\n    height: auto;\n    max-height: 240px;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
